// extracted by mini-css-extract-plugin
module.exports = {"cards":"List_cards__2A4ql","wrapper":"List_wrapper__3mEHD"};